function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1V5.5",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 12L19 12",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 12L1 12",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 18.5V23",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 7.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgPlace = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Place.1923a142.svg";
export { ForwardRef as ReactComponent };